module.exports = __webpack_public_path__ + "static/media/own-choosetopping-icon.ec2fe331.svg";